import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { IqaccontentListComponent } from './iqaccontent-list/iqaccontent-list.component';
import { IqaccontentCreateComponent } from './iqaccontent-create/iqaccontent-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: IqaccontentListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: IqaccontentCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'iqac-content-create/:id',
        component: IqaccontentCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IqacContentRoutingModule { }
